import React from "react";
import "./choose.css";

const WeHelpSection = () => {
  return (
    <div className="we-help-section">
      <div className="container">
        <div className="row justify-content-between">
          
          {/* Left Images */}
          <div className="col-lg-7 mb-5 mb-lg-0">
            <div className="imgs-grid">
              <div className="grid grid-1">
                <img src="/images/img-grid-1.jpg" alt="img1" />
              </div>
              <div className="grid grid-2">
                <img src="/images/img-grid-2.jpg" alt="img2" />
              </div>
              <div className="grid grid-3">
                <img src="/images/ancient.png" alt="img3" />
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="col-lg-5 ps-lg-5">
            <h2 className="section-title mb-4">
              We Help You Make Modern Interior Design
            </h2>

            <p>
              Founded in 2021 by professional experts in the Furniture & Interiors industry, deeply passionate about
modern design, aesthetics, ergonomics and functionality. The brand concept is based on the principles of
timeless designs, natural and sustainable materials, textures and craftsmanship that bring warmth,
durability and care with sophisticated functionality into every home, institution and commercial facility.
            </p>

            <ul className="list-unstyled custom-list my-4">
              <li>Craftmanship Defined by Comfort and Style
Introducing our latest collections with the theme of fusiontive design and timeless comfort. Discover highquality Furniture products, styles & finishes, crafted with sustainable and natural materials, aesthetically
designed for your interior spaces and lifestyle!</li>
              <li>NAVYAN COLLECTION
The Navyan Collection is a study in understated elegance and
natural form.
Drawing from the elegance of the Navyan cabinet, this complete
collection embodies the principles of mid-century Scandinavian
design.
Each piece—from the gracefully tapered legs to the warm wood
tones—is crafted to create a harmonious and inviting living
space.
</li>
              <li>The Artisan Forge Collection is a fantastic combination of
materials! Incorporating iron, mango wood, and green marble
adds a sophisticated, high-end feel to the collection.</li>
              <li>This collection is a tribute to natural strength and refined
craftsmanship. It harmonizes the organic warmth of wood and
stone with the robust honesty of metalwork, creating pieces that
are both timeless and contemporary look.</li>
            </ul>

            <p>
               <button className="btn btn-primary explore-btn">
  Explore
</button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeHelpSection;